import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { SetEntries, SavedFiltersModel } from '../../models/saved-filters.model';

// identifier
export const SAVED_FILTERS_SLICE_ID = 'savedFilters';

// default state
const initialState: SavedFiltersModel = {
  entries: undefined,
  savedFilterKey: undefined,
};

//slice
const savedFiltersSlice = createSlice({
  name: SAVED_FILTERS_SLICE_ID,
  initialState,
  reducers: {
    setSavedFiltersEntries: (state: SavedFiltersModel, action: PayloadAction<SetEntries>) => {
      const { entries } = action.payload;
      state.entries = entries;
    },
    setSavedFilterKey: (
      state: SavedFiltersModel,
      action: PayloadAction<{ datasetId: string; value: number | undefined }>
    ) => {
      const { datasetId, value } = action.payload;
      if (!state.savedFilterKey) {
        state.savedFilterKey = {};
      }

      state.savedFilterKey[datasetId] = value;
    },
  },
});

//selectors
export const selectSavedFiltersEntries = (state: RootState) => state.savedFilters.entries;
export const selectSavedFilterKey = (state: RootState, datasetId: string) =>
  state.savedFilters.savedFilterKey?.[datasetId];

//actions
export const { setSavedFiltersEntries, setSavedFilterKey } = savedFiltersSlice.actions;

//reducer
export default savedFiltersSlice;
